// import LanguageSelect from "@/components/Language/LanguageSelect";
// import Message from "@/components/Message/Message"; //'@/pages/message'
// import PageBack from "@/components/PageBack";
// import ThemeIconButton from "@/components/ThemeIconButton/ThemeIconButton"; //'../MobileThemeIconButton'
// import RouteConstant from "@/constant/RouteConstant";
import useSettings from "@/hook/useSettings";
import MobileHeader from "@/pages/components/MobileHeader";
import MobileLoginHeader from "@/pages/components/MobileLoginHeader";
import { getToken } from "@/redux/slices/user";
// import { StyledAppMenu } from "@/styles/CommonStyledComponents";
// import { isGuideFinished } from "@/utils/userUtils";
// import { Box, IconButton, Stack, Typography, useTheme } from "@mui/material";
// import useMobileDetect from "next-device-detection";
// import { enqueueSnackbar } from "notistack";
// import { useEffect, useRef, useState } from "react";
// import { useTranslation } from "react-i18next";
// import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
// import RpAvatar from "../RpAvatar";
// import RpIcon from "../RpIcon";
// import classes from "./Header.module.css";

export const APP_SETTINGS = {
  ACCOUNT: "account",
  PROFILE: "profile",
  CHART: "chart",
  ABOUTUS: "aboutus",
  LOGOUT: "logout",
};



function Header({}) {

  const { settings } = useSettings();

  const navigate = useNavigate();
  const location = useLocation();
  // const detectMobile = useMobileDetect();
  const str = location.pathname.split("/");
  let getHerf = "";
  if (str[2] != undefined) {
    getHerf = str[1] + " " + str[2];
  } else {
    getHerf = str[1];
  }





  const isLogin = !!getToken();

  return (
    <>
      {!isLogin && (
        <MobileLoginHeader />
      )}
      {isLogin && (
        <MobileHeader />
      )}
    </>
  );
}

export default Header;
